<template>
	<popup-view class="context-popup-view" v-bind="$attrs" @close="$emit('close')">
		<div :class="getClasses(action)" v-for="(action, i) in actions" v-bind:key="i" @click="exec($event, action)">{{ action && action.label ? action.label : '' }}</div>
	</popup-view>
</template>

<script>
	export default {
		props: {
			actions: {
				type: Array,
				default: function () {
					return [];
				}
			}
		},
		methods: {
			getClasses(action) {
				let c = ['action'];

				if (action && action.action) {
					c.push('clickable');
				}

				if (!action) {
					c.push('separator');
				}

				if (action && typeof action.enabled != 'undefined' && !action.enabled) {
					c.push('disabled');
				}

				if (action && action.highlight) {
					c.push('highlight');
				}

				if (action && action.classes) {
					c = c.concat(action.classes);
				}

				return c;
			},
			exec(e, action) {
				if (!action) {
					return;
				}

				if (action.enabled !== null && action.enabled == false) {
					return;
				}

				if (action.action) {
					this.$emit('close');
					action.action(e);
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	.context-popup-view {
		& > .action {
			text-align: left;
			padding: 10px 40px 10px 20px;
			font-size: 12px;
			white-space: nowrap;

			&.clickable {
				cursor: pointer;

				&:hover {
					background-color: rgb(248, 246, 246);
				}
			}

			&.separator {
				background-color: rgb(233, 233, 233);
				height: 1px;
				padding: 0;
			}

			&.highlight {
				font-weight: bold;
			}

			&.disabled {
				color: rgb(201, 201, 201);
				cursor: default;

				&:hover {
					background-color: white;
				}
			}
		}
	}
</style>